import {metaConstants} from "_constants";

const INITIAL_STATE = {
    fbPhotos: {
        data: {},
        loading: false,
        error: null,
    },
    fbVideos: {
        data: {},
        loading: false,
        error: null,
    },
};

export function metaReducer(state = INITIAL_STATE, action) {
    switch (action.type) {

        case metaConstants.GET_FB_PHOTOS_REQUEST:
            return {...state, fbPhotos: {...state.fbPhotos, loading: true, error: null}};
        case metaConstants.GET_FB_PHOTOS_SUCCESS:
            return {...state, fbPhotos: {data: action.payload, loading: false, error: null}};
        case metaConstants.GET_FB_PHOTOS_FAILURE:
            return {...state, fbPhotos: {...state.fbPhotos, loading: false, error: action.error}};

        case metaConstants.GET_FB_VIDEOS_REQUEST:
            return {...state, fbVideos: {...state.fbVideos, loading: true, error: null}};
        case metaConstants.GET_FB_VIDEOS_SUCCESS:
            return {...state, fbVideos: {data: action.payload, loading: false, error: null}};
        case metaConstants.GET_FB_VIDEOS_FAILURE:
            return {...state, fbVideos: {...state.fbVideos, loading: false, error: action.error}};

        default:
            return state
    }
}



